import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import CompanyLogo from "../assets/images/png/ask-and-associates-logo-1.png";
import { navLinks } from "../data";
import { Link, NavLink } from "react-router-dom";
import PrimaryBtn from "./PrimaryBtn";

const Header = () => {
  return (
    <nav aria-label="Main Navigation">
      <Navbar collapseOnSelect expand="lg" className="bg-white p-3">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src={CompanyLogo}
              alt="ASK & Associates architecture and construction consultancy logo"
              className="company-logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto gap-2 pt-4 pt-lg-0">
              {navLinks.map((link) => (
                <Nav.Link
                  key={link.id}
                  as={NavLink}
                  to={link.path}
                  className="text-capitalize border-top-0 border-start-0 border-end-0 border-silver-chalice border-lg-0 text-eerie-black fw-500 ps-3 px-lg-4 rounded-lg-pill"
                  activeclassname="bg-tea-green"
                >
                  {link.label}
                </Nav.Link>
              ))}
              <div className="">
                <PrimaryBtn label={"Contact Architects"} path={"/contact"} />
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </nav>
  );
};

export default Header;
